import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TPartnerAdditionalOwner } from "@zeal/common";

export type TPostGeneratePartnerAdditionalOwnerLinkParams = {
  whiteLabelID: string;
  existingAdditionalOwner?: TPartnerAdditionalOwner;
};

export const postGeneratePartnerAdditionalOwnerLink = (
  axios: IAxiosInstance
) => {
  return async (
    params: TPostGeneratePartnerAdditionalOwnerLinkParams
  ): Promise<string> => {
    const { whiteLabelID, existingAdditionalOwner } = params;
    const response = await axios.noRetry.post<{ data: string }>(
      `/api/partners/${whiteLabelID}/generate-additional-owner-link`,
      { existingAdditionalOwner }
    );
    return response.data.data;
  };
};
